"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _UIStepperInput = _interopRequireDefault(require("UIComponents/input/UIStepperInput"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _PriceDisplay = _interopRequireDefault(require("../common/pricing/PriceDisplay"));

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

var _MerchandiseSelectors = require("../../selectors/MerchandiseSelectors");

var _ContactsSelectors = require("../../selectors/ContactsSelectors");

var SmallStepperInput = (0, _styledComponents.default)(_UIStepperInput.default).withConfig({
  displayName: "Mon386Stepper__SmallStepperInput",
  componentId: "sc-1ozgskq-0"
})(["min-width:60px;width:", ";display:inline-flex !important;margin:0 2px;& input{font-size:14px;height:34px;padding:6px !important;}& .UIButtonGroup{width:24px !important;margin-left:-25px !important;}"], function (_ref) {
  var value = _ref.value;
  return "calc(" + value.toString().length + "em + 30px)";
});

var Mon386Stepper = function Mon386Stepper(_ref2) {
  var merchandiseId = _ref2.merchandiseId,
      additionalUnitQuantity = _ref2.additionalUnitQuantity,
      setAdditionalUnitQuantity = _ref2.setAdditionalUnitQuantity,
      activeTerm = _ref2.activeTerm,
      currencyCode = _ref2.currencyCode,
      getAdditionalContactsMonthlyCost = _ref2.getAdditionalContactsMonthlyCost,
      merchandiseMap = _ref2.merchandiseMap,
      getQuantityMultiplier = _ref2.getQuantityMultiplier;
  var _merchandiseMap$merch = merchandiseMap[merchandiseId],
      min = _merchandiseMap$merch.includedAdditionalUnits,
      max = _merchandiseMap$merch.maxAdditionalUnits,
      additionalUnitMerchId = _merchandiseMap$merch.additionalUnitMerchId;
  var unitType = merchandiseMap[additionalUnitMerchId].units;
  var stepSize = getQuantityMultiplier(merchandiseId) || 1;

  var getStepperMessageKey = function getStepperMessageKey() {
    if (unitType === 'contact') return 'mon386.contactsSelection_jsx';else if (unitType === 'user') return 'mon386.usersSelection_jsx';
    return null;
  };

  var renderHelpText = function renderHelpText() {
    if (unitType === 'contact') {
      return _react.default.createElement(_FormattedJSXMessage.default, {
        message: "mon386.contactsSubtext.additionalContacts_jsx",
        elements: {
          Price: _PriceDisplay.default
        },
        options: {
          currencyCode: currencyCode,
          price: getAdditionalContactsMonthlyCost(merchandiseId, activeTerm)
        }
      });
    } else if (unitType === 'user') {
      return _react.default.createElement(_FormattedMessage.default, {
        message: "mon386.usersSubtext.freeUsers"
      });
    }

    return null;
  };

  var getNumUnits = function getNumUnits() {
    var numUnits = additionalUnitQuantity + min;
    var roundedNumUnits = Math.ceil(numUnits / stepSize) * stepSize;
    return roundedNumUnits < min ? min : roundedNumUnits;
  };

  return _react.default.createElement("div", {
    className: "m-top-4 text-center"
  }, _react.default.createElement(_Small.default, {
    use: "help",
    style: {
      lineHeight: '30px'
    }
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: getStepperMessageKey(),
    elements: {
      Input: SmallStepperInput
    },
    options: {
      onChange: function onChange(_ref3) {
        var value = _ref3.target.value;
        return setAdditionalUnitQuantity(value - min);
      },
      value: getNumUnits(),
      min: min,
      max: max || 999999,
      stepSize: stepSize
    }
  }), _react.default.createElement(_UIHelpIcon.default, {
    style: {
      marginLeft: '2px'
    },
    size: "small",
    title: renderHelpText()
  })));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    getAdditionalContactsMonthlyCost: (0, _PricingSelectors.getAdditionalContactsMonthlyCostSelector)(state),
    merchandiseMap: (0, _MerchandiseSelectors.merchandiseSelector)(state),
    getQuantityMultiplier: function getQuantityMultiplier(merchId) {
      return (0, _ContactsSelectors.contactsQuantityMultiplierSelector)(state, merchId);
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Mon386Stepper);

exports.default = _default;
module.exports = exports.default;